import {
    LOAD_CART,
    ADD_PRODUCT,
    REMOVE_PRODUCT,
    GET_SLOTS,
    DELIVERY_DATE,
    DELIVERY_TIME_SLOT,
    // Phase 2 actions
    LOAD_PHASE2_CART,
    ADD_PHASE2_PRODUCT,
    REMOVE_PHASE2_PRODUCT,
    UPDATE_PHASE2_CART,
    CLEAR_PHASE2_CART,
    // Error actions
    CART_STORE_LIMITATION_ERROR,
    CLEAR_CART_ERROR,
} from "./actionTypes";

const initialState = {
    // Phase 1 (Sprint) Cart
    products: [],
    productToAdd: null,
    productToRemove: null,

    // Phase 2 (Relay) Cart
    phase2Products: [],
    phase2ProductToAdd: null,
    phase2ProductToRemove: null,

    // Error handling
    error: null,
    storeLimitationError: null,

    // Common
    timeSlots: [],
    futureDateData: null,
    deliveryDate: null,
    deliveryTimeSlot: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // Phase 1 (Sprint) Cart Actions
        case LOAD_CART:
            return {
                ...state,
                products: action.payload,
                // Canonical cart replace must clear stale "pending add" so FloatCart
                // does not replay ADD_PRODUCT when remounting or on route transitions.
                productToAdd: null,
                error: null,
                storeLimitationError: null,
            };
        case ADD_PRODUCT:
            return {
                ...state,
                productToAdd: Object.assign({}, action.payload),
                error: null,
                storeLimitationError: null,
            };
        case REMOVE_PRODUCT:
            return {
                ...state,
                productToRemove: Object.assign({}, action.payload)
            };

        // Phase 2 (Relay) Cart Actions
        case LOAD_PHASE2_CART:
            return {
                ...state,
                phase2Products: action.payload,
                error: null,
                storeLimitationError: null,
            };
        case ADD_PHASE2_PRODUCT:
            return {
                ...state,
                phase2ProductToAdd: Object.assign({}, action.payload),
                error: null,
                storeLimitationError: null,
            };
        case REMOVE_PHASE2_PRODUCT:
            return {
                ...state,
                phase2ProductToRemove: Object.assign({}, action.payload)
            };
        case UPDATE_PHASE2_CART:
            return {
                ...state,
                phase2Products: action.payload,
                error: null,
                storeLimitationError: null,
            };
        case CLEAR_PHASE2_CART:
            return {
                ...state,
                phase2Products: [],
                phase2ProductToAdd: null,
                phase2ProductToRemove: null,
                error: null,
                storeLimitationError: null,
            };

        // Error handling actions
        case CART_STORE_LIMITATION_ERROR:
            return {
                ...state,
                error: action.payload.error,
                storeLimitationError: {
                    message: action.payload.message,
                    cartItems: action.payload.cartItems,
                    timestamp: new Date().toISOString(),
                },
            };
        case CLEAR_CART_ERROR:
            return {
                ...state,
                error: null,
                storeLimitationError: null,
            };

        // Common actions
        case GET_SLOTS:
            return {
                ...state,
                timeSlots: action.payload.timeSlots,
                futureDateData: action.payload.futureDateData,
            };
        case DELIVERY_DATE:
            return {
                ...state,
                deliveryDate: action.payload
            };
        case DELIVERY_TIME_SLOT:
            return {
                ...state,
                deliveryTimeSlot: action.payload
            };
        default:
            return state;
    }
}
